<template>
  <BootstrapVueTable
    :title="title"
    :subtitle="subtitle"
    :items="table_data"
    :fields="table_fields" />
</template>

<script>
import axios from 'axios'
import errorRoutingMixin from '@/mixins/errorRoutingMixin'
import data_formats from '@/utils/data_formats'
import BootstrapVueTable from '@/components/BootstrapVueTable'

export default {
  name: 'Project_loss_provisions',
  components: {BootstrapVueTable},
  mixins: [errorRoutingMixin],
  props: ['reference_entity', 'reference_year', 'reference_month'],
  data () {
    return {
      title: "Provisions de risque",
      subtitle: "Cette table présente les provisions de risques créées par projet. Elle présente également les budgets disponibles selon AGP et comptabilité.",
      raw_data: [],
      table_data: [],
      table_fields: [],
    }
  },
  watch: {
    all_props () {
      this.load_server_data()
    }
  },
  created () {
    this.load_server_data()
  },
  computed: {
    all_props () {
      return [
        this.reference_entity,
        this.reference_year,
        this.reference_month  
      ]
    },
  },
  methods: {
    load_server_data () {
      if (! this.reference_entity) return  // If user is not yet authenticated. do nothing
      let url = 'webapi/loss-provisions?entity=' + this.reference_entity + '&year=' + this.reference_year + '&month=' + this.reference_month 
      axios.get(url, {headers: {'Authorization': 'Bearer ' + this.$cookies.get('jwt_access')}})
        .then(response => this.raw_data = response.data)
        .then(_ => this.fill_table())
        .catch(error => {
          console.log(error)
          this.$router.push(this.routeOnError(error.response.status))
        })
    },

    fill_table() {
      let year_columns = Object.keys(this.raw_data).filter((column_name) => column_name[0] === '2')
      this.table_data = data_formats.col_to_row_format(this.raw_data)
      let sortable = {sortable: true}
      let number_format = {formatter: data_formats.number_format_frch_rounded, class: 'text-right', ...sortable}
      let table_fields = [
        {key: 'IDPROJECTHESSO', label: 'No.', ...sortable}, 
        {key: 'PROJECTMANAGERINITIAL', label: 'Resp.', ...sortable}, 
        {key: 'PROJECTACRONYM', label: 'Acronyme', ...sortable},
        {key: 'ProjectStatus', label: 'Statut', ...sortable}
      ]
      table_fields = table_fields.concat(year_columns.map(
        (column_name) => ({key: column_name, label: "Provision "+column_name, ...number_format})))
      table_fields = table_fields.concat([
        {key: 'AgpRemainingBudget', label: 'Solde AGP actuel', ...number_format},
        {key: 'AccountingRemainingBudget', label: 'Solde compta. actuel', ...number_format}
      ])
      this.table_fields = table_fields
    },
  }
}
</script>